import {
  autoPhotoLabels,
  initErrors,
} from '../../data/constants/Contrats/contratRattacher';
import {
  IErrors,
  IValues,
} from '../../data/types/interface/Contrats/contratRattacher';
import {MESSAGE_VALIDATION} from './validation';

export interface IValidate {
  isError: boolean;
  errors: IErrors;
}
export const validate = (
  values: IValues,
  type: string,
  arePhotosRequired: boolean,
): IValidate => {
  const propertyException: Array<string> = ['garanties', 'arePhotosRequired'];
  let errors: IErrors = initErrors;
  let isError: boolean = false;

  if (type == 'auto') {
    propertyException.push('duration');

    if (!arePhotosRequired) {
      propertyException.push(...autoPhotoLabels.map(label => label.name));
    }
  }

  // Check required values
  Object.entries(values).forEach(element => {
    if (
      (element[1] === '' ||
        element[1] === null ||
        element[1] === 'INVALID INPUT' ||
        (typeof element[1] === 'boolean' && !element[1]) ||
        (Array.isArray(element[1]) && element[1].length === 0)) &&
      !propertyException.includes(element[0])
    ) {
      errors = {...errors, [element[0]]: MESSAGE_VALIDATION.requiredField};
      isError = true;
    }
  });

  console.log(isError, errors);

  return {
    isError,
    errors,
  };
};
